// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"347902b6","239":"677f6096","455":"22460f5f","488":"3562b049","977":"347f8211"}[chunkId] + ".chunk.js";
};